import { IdentityUserAri } from '@atlassian/ari';

/** Keeps the identity probe and full profile query on the same account ID. */
export function profileQueryAccountId(userId: string): string {
	return IdentityUserAri.check(userId) ? IdentityUserAri.parse(userId).userId : userId;
}
